"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultProps = exports.propTypes = exports.config = void 0;

var _spauiUtils = require("@tencent/spaui-utils");

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/

/**
 * @fileoverview 组件参数配置
 */

/**
 * 属性说明
 * @property {titleline} 默认支持参数
 * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
 * @property {titleline} 基础属性
 * @property {array} [data=[]] 对应的按钮选项数据（有值的时候会忽略children，改成向Button透传数据）
 * @property {bool} [vertical=false] 是否垂直
 * @property {titleline} 选项切换属性
 * @property {string} [value=''] 选中的按钮
 * @property {bool} [multiple=false] 是否多选
 * @property {func} [onChange] 点击回调<br /> onChange=(event, value, buttonProps)
 * @property {string} [activeDisplayType='primary'] 点击触发焦点的样式<br />对应spaui-button的displayType
 */
var config = {
  data: {
    type: _spauiUtils.PropTypes.array
  },
  value: {
    type: _spauiUtils.PropTypes.any,
    defaultValue: ''
  },
  multiple: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: false
  },
  onChange: {
    type: _spauiUtils.PropTypes.func
  },
  activeDisplayType: {
    type: _spauiUtils.PropTypes.string,
    defaultValue: 'primary'
  },
  vertical: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: false
  },
  justified: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: false
  },
  block: {
    type: _spauiUtils.PropTypes.bool,
    defaultValue: false
  },
  bsClass: {
    type: _spauiUtils.PropTypes.string,
    defaultValue: 'spaui-button-group'
  }
}; // 转化成PureComponent组件的配置

exports.config = config;
var configData = (0, _spauiUtils.formatProps)(config); // 导出

var propTypes = configData.propTypes;
exports.propTypes = propTypes;
var defaultProps = configData.defaultProps;
exports.defaultProps = defaultProps;
var _default = {
  config: config,
  propTypes: propTypes,
  defaultProps: defaultProps
};
exports["default"] = _default;